/** Sales domain API — tipos puros del dominio. */
export type {
  SaleDetail,
  SaleDetailDiscount,
  SaleDetailItem,
  SaleDetailPayment,
  SaleListRow,
  FiscalMode,
  SaleStatus,
} from './domain/salesTypes';

export { SaleAlreadyVoidedError } from './domain/saleErrors';
